import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M12.014 4H6a2 2 0 0 0-2 2v11.933a2 2 0 0 0 1.99 2l12.027.058.16-.006a2 2 0 0 0 1.85-1.995v-5.995"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": ".8",
  d: "m21 5.42-.8-.002c-2.99-.008-4.484-.012-5.534.744-.35.25-.656.556-.908.905C13 8.116 13 9.611 13 12.6m8-7.18a.56.56 0 0 0-.14-.378C20.248 4.318 18.657 3 18.657 3M21 5.42a.56.56 0 0 1-.14.338c-.612.724-2.204 2.042-2.204 2.042"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }